<template>
    <ContentPage title="Informativa Privacy" sub-title="Ai sensi dell’art. 13 del Regolamento (UE) 2016/679">
        <p>
            Adorea S.r.l. (Adorea S.r.l. (Fleequid)), con sede in Via provinciale per Bizzarone, 43 – 22077 Olgiate Comasco (CO), P. IVA. e C.F.
            04114790134, iscritta al Registro delle Imprese di Como al numero 04114790134, capitale sociale 10.000,00€ i.v. (“
            <strong>Adorea S.r.l. (Fleequid)</strong>”) in qualità di titolare del trattamento, Le rilascia la presente informativa sul trattamento
            dei Suoi dati personali ai sensi dell’Art. 13 del Regolamento (UE) n. 2016/679 ("<strong>GDPR</strong>").
        </p>

        <BaseVerticalStack as="ol" class="list-inside list-decimal">
            <li>
                <h3 class="text-highlighted inline-block font-bold">Finalità del trattamento e base giuridica</h3>
                <p class="my-4">
                    Adorea S.r.l. (Fleequid) è una società che si occupa della gestione di aste online relative a veicoli industriali, dedicate ad una
                    clientela business. Quando una società si registra su Adorea S.r.l. (Fleequid) per partecipare ad un’asta, sarà richiesto di
                    indicare alcuni dati del relativo referente, ossia nome, cognome, email e numero di telefono (“<strong>Dati</strong>”). Tali dati
                    saranno trattati da Adorea S.r.l. (Fleequid), anche per il tramite di strumenti elettronici/digitali, esclusivamente per le
                    seguenti finalità e basi giuridiche:
                </p>
                <div class="my-4 grid grid-cols-[40px_1fr_1fr] grid-rows-[24px_1fr_1fr] gap-2">
                    <div class="font-bold">N.</div>
                    <div class="font-bold">Finalità</div>
                    <div class="font-bold">Base giuridica</div>
                    <div class="font-bold">1.1</div>
                    <div>
                        Consentire la partecipazione all’asta come richiesto dall’utente, garantendone il normale svolgimento e la possibilità di
                        contattare il referente della società in caso di aggiudicazione
                    </div>
                    <div>Esecuzione del contratto</div>
                    <div class="font-bold">1.2</div>
                    <div>Invio materiale informativo relativo ai servizi di Adorea S.r.l. (Fleequid)</div>
                    <div>
                        Legittimo interesse, sulla base dell’art. 130, comma 4, del d.lgs. 196/2003. L’interessato potrà opporsi in ogni momento al
                        trattamento, in maniera agevole e gratuitamente.
                    </div>
                </div>
                <p class="my-4">
                    Fornire i Dati Personali è essenziale al fine di partecipare all’asta e di usufruire dei servizi di Adorea S.r.l. (Fleequid), ed
                    il mancato conferimento pregiudicherebbe pertanto tale partecipazione e la relativa instaurazione del rapporto contrattuale con
                    Adorea S.r.l. (Fleequid).
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Comunicazione e trasferimento dei Dati</h3>
                <p class="my-4">
                    I Dati potranno essere trattati anche dalle società appaltatrici che svolgono attività connesse, strumentali o di supporto a
                    quelle di Adorea S.r.l. (Fleequid) e di cui Adorea S.r.l. (Fleequid) può avvalersi per eseguire le finalità sopra indicate. Gli
                    stessi agiranno quali responsabili del trattamento, secondo le istruzioni di Adorea S.r.l. (Fleequid). Qualora nella condivisione
                    delle informazioni i Dati fossero trasferiti in Paesi al di fuori dello Spazio Economico Europeo, Adorea S.r.l. (Fleequid) si
                    assicurerà che i Dati siano trasferiti in conformità alla presente informativa e come previsto dalle normative applicabili sulla
                    protezione dei dati.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Conservazione dei Dati</h3>
                <p class="my-4">
                    I Suoi Dati saranno conservati per il tempo strettamente necessario ad adempiere alle finalità di cui al punto 1 che precede,
                    ossia 10 anni dalla cessazione degli effetti del contratto. Tale periodo di conservazione è giustificato, quanto alle finalità di
                    marketing, dalla particolare natura dei beni oggetto delle aste gestite da Adorea S.r.l. (Fleequid), ossia veicoli industriali di
                    elevato valore. Una volta decorso tale periodo, i Dati saranno cancellati o anonimizzati.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Diritti dell’interessato</h3>
                <p class="my-4">
                    Lei potrà esercitare in qualunque momento il diritto di accesso ai propri Dati e alle seguenti informazioni: finalità del
                    trattamento; categorie di dati personali in questione; destinatari o categorie di destinatari a cui i dati possono essere
                    comunicati; ove possibile, il periodo di conservazione dei dati, secondo quanto previsto dall'art. 15 GDPR; il diritto di
                    rettifica dei dati personali inesatti di cui all'art. 16 GDPR; il diritto di ottenere la cancellazione dei dati che li riguardano,
                    ove ricorrano le condizioni di cui all'art. 17 GDPR; il diritto di richiedere la limitazione del trattamento, ove ricorrano le
                    condizioni di cui all'art. 18 GDPR; il diritto alla portabilità dei dati ove ricorrano le condizioni di cui all'art. 20 GDPR; il
                    diritto di opporsi al trattamento, incluso il trattamento per finalità di marketing, ove ricorrano le condizioni di cui all'art.
                    21 GDPR. Lei potrà inoltre sempre proporre reclamo all’Autorità Garante per la Protezione dei Dati Personali secondo le modalità
                    illustrate sul sito
                    <NuxtLink class="text-primary hover:underline" to="https://www.garanteprivacy.it" target="_blank" external>
                        www.garanteprivacy.it</NuxtLink
                    >.
                </p>
                <p class="my-4">
                    Per effettuare richieste o domande in merito alle nostre prassi in materia di privacy, La invitiamo a contattarci all'indirizzobas
                    <FleequidEmailLink type="privacy" />. Rispondiamo a tutte le richieste degli utenti che desiderano esercitare i propri diritti in
                    materia di protezione dei dati personali in conformità alle leggi vigenti sulla protezione dei dati.
                </p>
            </li>
        </BaseVerticalStack>
    </ContentPage>
</template>
